import React, { useState, useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { createCanvas } from 'canvas';
import '../styles/armsform.css';

const Passport = () => {
    const [formData, setFormData] = useState({
        token_id: 'E Passport - ',
        local_no: '',
        letter_no: '',
        date: '',
        date_2: '',
        name: '',
        father_name: '',
        gender: '',
        cnic: '',
        address: '',
        n_verification: '',
        t_report: '',
        i_report: '',
        phone_no: '',
        status: '',
        regional_office: '',
    });

    const [message, setMessage] = useState(null);
    const [barcodeImage, setBarcodeImage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const generateBarcode = (token_Id) => {
        try {
            const canvas = createCanvas();
            // Optimize barcode to reduce size
            JsBarcode(canvas, token_Id, { 
                format: "CODE128",
                width: 1,
                height: 40,
                displayValue: false,
                margin: 0
            });
            // Use JPEG with compression to reduce size
            return canvas.toDataURL("image/jpeg", 0.5);
        } catch (error) {
            console.error("Barcode generation error:", error);
            return null;
        }
    };

    useEffect(() => {
        if (formData.token_id && formData.token_id.trim() !== '') {
            const barcode = generateBarcode(formData.token_id);
            setBarcodeImage(barcode);
        } else {
            setBarcodeImage(null);
        }
    }, [formData.token_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        
        // Clear message when user starts typing
        if (message) {
            setMessage(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.token_id || !formData.local_no || !formData.date) {
            setMessage("Please fill in the required fields: Token ID, No, and Date.");
            return;
        }

        setIsSubmitting(true);

        try {
            console.log("Submitting Passport data...");
            
            // Create payload with optimized barcode
            const payload = {
                action: 'add',
                token_id: formData.token_id,
                local_no: formData.local_no,
                letter_no: formData.letter_no,
                date: formData.date,
                date_2: formData.date_2,
                name: formData.name,
                father_name: formData.father_name,
                gender: formData.gender,
                cnic: formData.cnic,
                address: formData.address,
                n_verification: formData.n_verification,
                t_report: formData.t_report,
                i_report: formData.i_report,
                phone_no: formData.phone_no,
                status: formData.status,
                regional_office: formData.regional_office
            };
            
            // Add optimized barcode if available
            if (barcodeImage) {
                payload.barcode = barcodeImage;
            }
            
            console.log("Payload size:", JSON.stringify(payload).length, "bytes");
            
            const response = await fetch('https://chaman.gob.pk/eac_backend/passcert.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            console.log("Response status:", response.status);
            
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            
            const result = await response.json();
            console.log("Server response:", result);
            
            if (result.status === "success") {
                setMessage(result.message);
                setFormData({
                    token_id: 'E Passport - ',
                    local_no: '',
                    letter_no: '',
                    date: '',
                    date_2: '',
                    name: '',
                    father_name: '',
                    gender: '',
                    cnic: '',
                    address: '',
                    n_verification: '',
                    t_report: '',
                    i_report: '',
                    phone_no: '',
                    status: '',
                    regional_office: '',
                });
                setBarcodeImage(null);
                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 2000);
            } else {
                // Handle specific errors
                if (result.message && result.message.includes("Data too long for column 'barcode'")) {
                    setMessage("Error: Barcode data too large. Please contact administrator.");
                } else if (result.message && result.message.includes("Field 'id' doesn't have a default value")) {
                    setMessage("Database Configuration Error: Please contact administrator to fix database settings.");
                } else {
                    setMessage("Error: " + (result.message || "Unknown error occurred"));
                }
                console.error("Server error:", result);
            }
        } catch (error) {
            console.error("Error submitting Passport form:", error);
            
            if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
                setMessage("Network error: Please check your internet connection and try again.");
            } else {
                setMessage("An error occurred while submitting the form. Please try again.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="lc-form-container">
            {/* Display error/success message */}
            {message && (
                <div className={`lc-message ${message.includes("success") ? 'success' : 'error'}`}>
                    {message}
                    <button 
                        onClick={() => setMessage(null)}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: 'inherit',
                            cursor: 'pointer',
                            marginLeft: '10px',
                            fontSize: '18px'
                        }}
                    >
                        ×
                    </button>
                </div>
            )}
            
            <form className="lc-form" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="token_id" 
                                value={formData.token_id} 
                                onChange={handleChange} 
                                className="lc-input" 
                                required 
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Recieved Date:</label>
                        <div className="lc-input-container">
                            <input 
                                type="date" 
                                name="date_2" 
                                value={formData.date_2} 
                                onChange={handleChange} 
                                className="lc-input"
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Regional Office:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="regional_office"
                                value={formData.regional_office}
                                onChange={handleChange}
                                className="lc-input"
                                required
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">No:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="local_no" 
                                value={formData.local_no} 
                                onChange={handleChange} 
                                className="lc-input" 
                                required 
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Issue Date:</label>
                        <div className="lc-input-container">
                            <input 
                                type="date" 
                                name="date" 
                                value={formData.date} 
                                onChange={handleChange} 
                                className="lc-input" 
                                required 
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Letter No:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="letter_no" 
                                value={formData.letter_no} 
                                onChange={handleChange} 
                                className="lc-input"
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Name:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="name" 
                                value={formData.name} 
                                onChange={handleChange} 
                                className="lc-input"
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Father Name:</label>
                        <div className="lc-input-container">
                            <input 
                                type='text' 
                                name="father_name" 
                                value={formData.father_name} 
                                onChange={handleChange} 
                                className="lc-input"
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Gender:</label>
                        <div className="lc-input-container">
                            <select 
                                name="gender" 
                                value={formData.gender} 
                                onChange={handleChange}
                                className="lc-select"
                                disabled={isSubmitting}
                            >
                                <option value="" disabled>Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">CNIC:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="cnic" 
                                value={formData.cnic} 
                                onChange={handleChange} 
                                className="lc-input"
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Resident of:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="address" 
                                value={formData.address} 
                                onChange={handleChange} 
                                className="lc-input"
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">National Verification:</label>
                        <div className="lc-input-container">
                            <select 
                                name="n_verification" 
                                value={formData.n_verification} 
                                onChange={handleChange}
                                className="lc-select"
                                disabled={isSubmitting}
                            >
                                <option value="" disabled>Select Verification</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Tehsildar Report:</label>
                        <div className="lc-input-container">
                            <select 
                                name="t_report" 
                                value={formData.t_report} 
                                onChange={handleChange}
                                className="lc-select"
                                disabled={isSubmitting}
                            >
                                <option value="" disabled>Select Report</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Thana Incharge Report:</label>
                        <div className="lc-input-container">
                            <select 
                                name="i_report" 
                                value={formData.i_report} 
                                onChange={handleChange}
                                className="lc-select"
                                disabled={isSubmitting}
                            >
                                <option value="" disabled>Select Report</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Phone No:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="phone_no" 
                                value={formData.phone_no} 
                                onChange={handleChange} 
                                className="lc-input"
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Status:</label>
                        <div className="lc-input-container">
                            <select 
                                name="status" 
                                value={formData.status} 
                                onChange={handleChange}
                                className="lc-select"
                                disabled={isSubmitting}
                            >
                                <option value="" disabled>Select Status</option>
                                <option value="Received">Received</option>
                                <option value="Ready">Ready</option>
                            </select>
                        </div>
                    </div>
                </div>
                <button 
                    type="submit" 
                    className="lc-submit-btn"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <>
                            <span style={{
                                display: 'inline-block',
                                width: '16px',
                                height: '16px',
                                border: '2px solid #fff',
                                borderTop: '2px solid transparent',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                marginRight: '8px'
                            }}></span>
                            Submitting...
                        </>
                    ) : 'Submit'}
                </button>
            </form>

            {showPopup && (
                <div className="lc-popup">
                    Data saved successfully!
                </div>
            )}
            
            <style jsx>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .lc-message {
                    padding: 10px 15px;
                    margin-bottom: 15px;
                    border-radius: 4px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .lc-message.success {
                    background-color: #d4edda;
                    color: #155724;
                    border: 1px solid #c3e6cb;
                }
                .lc-message.error {
                    background-color: #f8d7da;
                    color: #721c24;
                    border: 1px solid #f5c6cb;
                }
                .lc-submit-btn:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }
            `}</style>
        </div>
    );
};

export default Passport;